import './index.css'

const PlanetItem = props => {
  const {eachPlanet} = props
  const {imageUrl, name, description} = eachPlanet

  return (
    <div className="planet-item-container">
      <img src={imageUrl} alt={`planet ${name}`} className="planet-image" />
      <h1 className="planet-name">{name}</h1>
      <p className="planet-para">{description}</p>
    </div>
  )
}
export default PlanetItem
